"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "automation-body"
  }, [_c('h2', {
    staticClass: "a-title"
  }, [_vm._v("CONFIGURACIÓN DE AUTOMATIZACIÓN")]), _c('p', {
    staticClass: "a-subtitle"
  }, [_vm._v("Optimiza tu tiempo configurando respuestas automáticas, mensajes de bienvenida y publicaciones programadas.")]), _c('div', {
    staticClass: "automation-grid"
  }, [_c('div', {
    staticClass: "a-card"
  }, [_c('div', {
    staticClass: "a-header"
  }, [_vm._m(0), _vm._m(1), _c('label', {
    staticClass: "switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.settings.welcomeActive,
      expression: "settings.welcomeActive"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.settings.welcomeActive) ? _vm._i(_vm.settings.welcomeActive, null) > -1 : _vm.settings.welcomeActive
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.settings.welcomeActive,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.settings, "welcomeActive", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.settings, "welcomeActive", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.settings, "welcomeActive", $$c);
        }
      }
    }
  }), _c('span', {
    staticClass: "slider round"
  })])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.settings.welcomeActive,
      expression: "settings.welcomeActive"
    }],
    staticClass: "a-detail"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.settings.welcomeMsg,
      expression: "settings.welcomeMsg"
    }],
    attrs: {
      "placeholder": "¡Hola! Gracias por suscribirte a mi canal..."
    },
    domProps: {
      "value": _vm.settings.welcomeMsg
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.settings, "welcomeMsg", $event.target.value);
      }
    }
  }), _c('button', {
    staticClass: "a-save-mini"
  }, [_vm._v("GUARDAR")])])]), _c('div', {
    staticClass: "a-card"
  }, [_c('div', {
    staticClass: "a-header"
  }, [_vm._m(2), _vm._m(3), _c('label', {
    staticClass: "switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.settings.aiActive,
      expression: "settings.aiActive"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.settings.aiActive) ? _vm._i(_vm.settings.aiActive, null) > -1 : _vm.settings.aiActive
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.settings.aiActive,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.settings, "aiActive", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.settings, "aiActive", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.settings, "aiActive", $$c);
        }
      }
    }
  }), _c('span', {
    staticClass: "slider round"
  })])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.settings.aiActive,
      expression: "settings.aiActive"
    }],
    staticClass: "a-detail"
  }, [_c('div', {
    staticClass: "ai-mode-selector"
  }, [_c('span', {
    class: {
      active: _vm.settings.aiMode === 'friendly'
    },
    on: {
      "click": function ($event) {
        _vm.settings.aiMode = 'friendly';
      }
    }
  }, [_vm._v("Amigable")]), _c('span', {
    class: {
      active: _vm.settings.aiMode === 'flirty'
    },
    on: {
      "click": function ($event) {
        _vm.settings.aiMode = 'flirty';
      }
    }
  }, [_vm._v("Seductor")]), _c('span', {
    class: {
      active: _vm.settings.aiMode === 'formal'
    },
    on: {
      "click": function ($event) {
        _vm.settings.aiMode = 'formal';
      }
    }
  }, [_vm._v("Formal")])]), _c('div', {
    staticClass: "ai-prompt-box"
  }, [_c('label', [_vm._v("Instrucciones de Personalidad (Prompt)")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.settings.aiPrompt,
      expression: "settings.aiPrompt"
    }],
    attrs: {
      "placeholder": "Ej: Responde siempre con un tono divertido, usa emojis y menciona que pronto habrá contenido nuevo..."
    },
    domProps: {
      "value": _vm.settings.aiPrompt
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.settings, "aiPrompt", $event.target.value);
      }
    }
  }), _c('button', {
    staticClass: "a-save-mini"
  }, [_vm._v("GUARDAR IA")])])])]), _c('div', {
    staticClass: "a-card"
  }, [_c('div', {
    staticClass: "a-header"
  }, [_vm._m(4), _vm._m(5), _c('label', {
    staticClass: "switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.settings.scheduleActive,
      expression: "settings.scheduleActive"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.settings.scheduleActive) ? _vm._i(_vm.settings.scheduleActive, null) > -1 : _vm.settings.scheduleActive
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.settings.scheduleActive,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.settings, "scheduleActive", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.settings, "scheduleActive", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.settings, "scheduleActive", $$c);
        }
      }
    }
  }), _c('span', {
    staticClass: "slider round"
  })])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.settings.scheduleActive,
      expression: "settings.scheduleActive"
    }],
    staticClass: "a-detail"
  }, [_vm._m(6)])]), _c('div', {
    staticClass: "a-card"
  }, [_c('div', {
    staticClass: "a-header"
  }, [_vm._m(7), _vm._m(8), _c('label', {
    staticClass: "switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.settings.spamActive,
      expression: "settings.spamActive"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.settings.spamActive) ? _vm._i(_vm.settings.spamActive, null) > -1 : _vm.settings.spamActive
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.settings.spamActive,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.settings, "spamActive", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.settings, "spamActive", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.settings, "spamActive", $$c);
        }
      }
    }
  }), _c('span', {
    staticClass: "slider round"
  })])])])])]);
};
var staticRenderFns = exports.staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "a-icon"
  }, [_c('i', {
    staticClass: "fa fa-hand-spock-o"
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "a-info"
  }, [_c('h4', [_vm._v("Mensaje de Bienvenida")]), _c('span', [_vm._v("Envía un mensaje privado a cada nuevo suscriptor.")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "a-icon"
  }, [_c('i', {
    staticClass: "fa fa-magic"
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "a-info"
  }, [_c('h4', [_vm._v("Respuestas con IA")]), _c('span', [_vm._v("Usa IA para contestar dudas frecuentes de tus fans.")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "a-icon"
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "a-info"
  }, [_c('h4', [_vm._v("Publicaciones Programadas")]), _c('span', [_vm._v("Tu contenido se subirá automáticamente en las horas de mayor tráfico.")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "schedule-stats"
  }, [_c('div', {
    staticClass: "stat-item"
  }, [_c('span', {
    staticClass: "val"
  }, [_vm._v("18:00 - 22:00")]), _c('span', {
    staticClass: "lbl"
  }, [_vm._v("Mejor horario hoy")])])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "a-icon"
  }, [_c('i', {
    staticClass: "fa fa-shield"
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "a-info"
  }, [_c('h4', [_vm._v("Filtro de Contenido")]), _c('span', [_vm._v("Bloquea automáticamente palabras ofensivas o links externos.")])]);
}];